function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["onClick", "isSelected", "style", "element", "className", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
var PREFIX = 'RectangularOption';
var classes = {
  optionStyles: "".concat(PREFIX, "-titleStyles"),
  selectedStyles: "".concat(PREFIX, "-selectedStyles")
};
function RectangularOption(_ref) {
  var onClick = _ref.onClick,
    isSelected = _ref.isSelected,
    style = _ref.style,
    element = _ref.element,
    className = _ref.className,
    children = _ref.children,
    other = _objectWithoutProperties(_ref, _excluded);
  var StyledRectangularOption = styled(element || Button)(function (_ref2) {
    var theme = _ref2.theme;
    return _defineProperty(_defineProperty(_defineProperty({}, "&.".concat(classes.optionStyles), {
      background: theme.palette.rectangularOption.background.primary,
      color: theme.palette.rectangularOption.font.primary,
      border: "1px solid ".concat(theme.palette.rectangularOption.border.primary),
      textTransform: 'none',
      borderRadius: '4px'
    }), "&.".concat(classes.selectedStyles), {
      background: theme.palette.rectangularOption.background.secondary,
      color: theme.palette.rectangularOption.font.secondary,
      border: "1px solid ".concat(theme.palette.rectangularOption.border.secondary)
    }), '&:hover', {
      background: theme.palette.rectangularOption.background.secondary,
      color: theme.palette.rectangularOption.font.secondary,
      border: "1px solid ".concat(theme.palette.rectangularOption.border.secondary)
    });
  });
  return /*#__PURE__*/React.createElement(StyledRectangularOption, _extends({
    className: clsx(classes.optionStyles, _defineProperty(_defineProperty({}, classes.selectedStyles, isSelected), className, className)),
    onClick: onClick,
    style: style
  }, other), children);
}
RectangularOption.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isSelected: PropTypes.bool,
  style: PropTypes.object
};
export default RectangularOption;